import { useTranslation } from "react-i18next";
/**
 * Provides localized user menu constants using i18next translations.
 *
 * This hook fetches translation strings from the "usermenu" namespace and
 * returns a structured object containing keys for user navigation and messages.
 *
 * @function UserMenuConstants
 * @returns {Object} Translated user menu constants
 * @returns {string} return.home - Translation for user home.
 * @returns {Object} return.messages - Group of translated message-related menu items.
 * @returns {string} return.messages.heading - Messages section heading.
 * @returns {Object} return.messages.lodgepurchase - Lodge Purchase translations.
 * @returns {string} return.messages.lodgepurchase.heading - Lodge Purchase heading.
 * @returns {string} return.messages.lodgepurchase.new - New Lodge Purchase label.
 * @returns {string} return.messages.lodgepurchase.list - Lodge Purchase list label.
 * @returns {Object} return.messages.akzs - Akzs request translations.
 * @returns {string} return.messages.akzs.heading - Akzs section heading.
 * @returns {string} return.messages.akzs.new - New Akzs request label.
 * @returns {string} return.messages.akzs.list - Akzs request list label.
 * @returns {Object} return.status - Status section translations.
 * @returns {string} return.status.list - Status list label.
 * @returns {Object} return.log - Log section translations.
 * @returns {string} return.log.list - Log list label.
 * @author rajeev.k
 * @example
 * const userMenu = UserMenuConstants();
 * console.log(userMenu.home); // "Dashboard" (depending on translations)
 */
var UserMenuConstants = function () {
    var usermenu = useTranslation("usermenu").t;
    return {
        home: usermenu("com.beo.dakz.user.home"),
        messages: {
            heading: usermenu("com.beo.dakz.user.messages.heading"),
            lodgepurchase: {
                heading: usermenu("com.beo.dakz.user.messages.lodgepurchase.heading"),
                old: usermenu("com.beo.dakz.user.messages.lodgepurchase.old"),
                new: usermenu("com.beo.dakz.user.messages.lodgepurchase.new"),
                list: usermenu("com.beo.dakz.user.messages.lodgepurchase.list"),
            },
            akzs: {
                heading: usermenu("com.beo.dakz.user.messages.akzs.heading"),
                new: usermenu("com.beo.dakz.user.messages.akzs.new"),
                list: usermenu("com.beo.dakz.user.messages.akzs.list"),
            },
            requestPurchaseIds: {
                heading: usermenu("com.beo.dakz.user.messages.requestPurchaseIds.heading"),
                new: usermenu("com.beo.dakz.user.messages.requestPurchaseIds.new"),
                list: usermenu("com.beo.dakz.user.messages.requestPurchaseIds.list"),
            },
            receive: {
                heading: usermenu("com.beo.dakz.user.receive.heading"),
                purchaseprocessids: {
                    heading: usermenu("com.beo.dakz.user.receive.purchaseprocessids.heading"),
                    details: usermenu("com.beo.dakz.user.receive.purchaseprocessids.details"),
                    list: usermenu("com.beo.dakz.user.receive.purchaseprocessids.list"),
                },
                akzs: {
                    heading: usermenu("com.beo.dakz.user.receive.akzs.heading"),
                    detail: usermenu("com.beo.dakz.user.receive.akzs.detail"),
                    list: usermenu("com.beo.dakz.user.receive.akzs.list"),
                },
                processpurchaseresult: {
                    heading: usermenu("com.beo.dakz.user.receive.processpurchaseresult.heading"),
                    detail: usermenu("com.beo.dakz.user.receive.processpurchaseresult.detail"),
                    list: usermenu("com.beo.dakz.user.receive.processpurchaseresult.list"),
                },
                error: {
                    heading: usermenu("com.beo.dakz.user.receive.error.heading"),
                    detail: usermenu("com.beo.dakz.user.receive.error.details"),
                    list: usermenu("com.beo.dakz.user.receive.error.list"),
                },
            },
        },
        status: {
            list: usermenu("com.beo.dakz.user.status.list"),
        },
        log: {
            list: usermenu("com.beo.dakz.user.log.list"),
        },
        admin: {
            dashboard: usermenu("com.beo.dakz.admin.home"),
            client: {
                heading: usermenu("com.beo.dakz.admin.client.heading"),
                newmandant: usermenu("com.beo.dakz.admin.client.newmandant"),
                mandantList: usermenu("com.beo.dakz.admin.client.mandantList"),
            },
            messagestatistics: usermenu("com.beo.dakz.admin.messagestatistics"),
            nonstampableitems: {
                heading: usermenu("com.beo.dakz.admin.nonstampableitems.heading"),
                new: usermenu("com.beo.dakz.admin.nonstampableitems.new"),
            },
            declarationstatistics: usermenu("com.beo.dakz.admin.declarationstatistics"),
        },
        address: { list: usermenu("com.beo.dakz.user.address.list") },
        options: { types: usermenu("com.beo.dakz.user.options.list.types") },
    };
};
export default UserMenuConstants;
